import { render, staticRenderFns } from "./select-card.vue?vue&type=template&id=ec88ce66&scoped=true&lang=pug&"
import script from "./select-card.vue?vue&type=script&lang=js&"
export * from "./select-card.vue?vue&type=script&lang=js&"
import style0 from "./select-card.vue?vue&type=style&index=0&id=ec88ce66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec88ce66",
  null
  
)

export default component.exports